<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          Backers
        </h1>
      </div>
    </section>
    <section class="search">
      <div class="ns-container">
        <div class="row">
          <TableServer :options="options" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    TableServer: () => import('@/components/_vue/TableServer'),
  },

  data() {
    return {
      options: {
        url: '/api/admin/backers',
        name: 'backers',
        columns: ['backerId', 'backerName', 'backer_email', 'amount', 'perk', 'userId', 'userName', 'user_email'],
        tableOptions: {
          perPage: 100,
          orderBy: {
            column: 'backerId',
            ascending: false,
          },
        },
      },
    };
  },
};
</script>
